import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../store/auth/auth.slice'
import tripsReducer from '../store/trips/trips.slice'
import invoicesReducer from '../store/invoices/invoices.slice'
import equipmentReducer from './equipments/equipments.slice'
import ordersReducer from './orders/orders.slice'
import companyReducer from './company/company.slice'
import driversReducer from './drivers/drivers.slice'
import { authApi } from './auth/auth.api'
import { taskAutomationApi } from './task-automation/task-automation.api'
import { tripsApi } from './trips/trips.api'
import { equipmentsApi } from './equipments/equipments.api'
import { driversApi } from './drivers/drivers.api'
import { ordersApi } from './orders/orders.api'
import { companyApi } from './company/company.api'
import { dispatchUsersApi } from './company/dispatch-users.api'
import { dispatchAuthApi } from './dispatch-auth/dispatch-auth.api'
import { invoicesApi } from './invoices/invoices.api'
import { ordersOldApi } from './orders/orders-old.api'
import { commissionsApi } from './commissions/commissions.api'
import { dashboardApi } from './dashboard/dashboard.api'
import { addressApi } from './address/address.api'
import { customerPortalApi } from './customer-portal/customer-portal.api'
import { customerPortalRuntimeApi } from './customer-portal/customer-portal-runtime.api'
import { cnApi } from './cn/cn.api'
import { loadConfirmationApi } from './load-confirmation/load-confirmation.api'
import { documentsApi } from './documents/documents.api'
import { expensesApi } from './expenses/expenses.api'
import { integrationsApi } from './integrations/integrations.api'
import { borderConnectApi } from './borderconnect/borderconnect.api'
import { subscriptionsApi } from './subscriptions/subscriptions.api'
import { driverPayApi } from './driver-pay/driver-pay.api'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    trips: tripsReducer,
    invoices: invoicesReducer,
    equipments: equipmentReducer,
    orders: ordersReducer,
    company: companyReducer,
    drivers: driversReducer,
    [authApi.reducerPath]: authApi.reducer,
    [tripsApi.reducerPath]: tripsApi.reducer,
    [equipmentsApi.reducerPath]: equipmentsApi.reducer,
    [taskAutomationApi.reducerPath]: taskAutomationApi.reducer,
    [driversApi.reducerPath]: driversApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [invoicesApi.reducerPath]: invoicesApi.reducer,
    [ordersOldApi.reducerPath]: ordersOldApi.reducer,
    [commissionsApi.reducerPath]: commissionsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [addressApi.reducerPath]: addressApi.reducer,
    [dispatchUsersApi.reducerPath]: dispatchUsersApi.reducer,
    [dispatchAuthApi.reducerPath]: dispatchAuthApi.reducer,
    [customerPortalApi.reducerPath]: customerPortalApi.reducer,
    [customerPortalRuntimeApi.reducerPath]: customerPortalRuntimeApi.reducer,
    [cnApi.reducerPath]: cnApi.reducer,
    [loadConfirmationApi.reducerPath]: loadConfirmationApi.reducer,
    [documentsApi.reducerPath]: documentsApi.reducer,
    [expensesApi.reducerPath]: expensesApi.reducer,
    [integrationsApi.reducerPath]: integrationsApi.reducer,
    [borderConnectApi.reducerPath]: borderConnectApi.reducer,
    [subscriptionsApi.reducerPath]: subscriptionsApi.reducer,
    [driverPayApi.reducerPath]: driverPayApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      tripsApi.middleware,
      taskAutomationApi.middleware,
      equipmentsApi.middleware,
      driversApi.middleware,
      ordersApi.middleware,
      companyApi.middleware,
      invoicesApi.middleware,
      ordersOldApi.middleware,
      commissionsApi.middleware,
      dashboardApi.middleware,
      addressApi.middleware,
      dispatchUsersApi.middleware,
      dispatchAuthApi.middleware,
      customerPortalApi.middleware,
      customerPortalRuntimeApi.middleware,
      cnApi.middleware,
      loadConfirmationApi.middleware,
      documentsApi.middleware,
      expensesApi.middleware,
      integrationsApi.middleware,
      borderConnectApi.middleware,
      subscriptionsApi.middleware,
      driverPayApi.middleware
    ),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
